module.exports = __webpack_public_path__ + "static/img/download_bg.3c491a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg.png
// module id = sF07
// module chunks = 0